// Generated by purs version 0.14.3
"use strict";
var Loading = (function () {
    function Loading() {

    };
    Loading.value = new Loading();
    return Loading;
})();
var Loaded = (function () {
    function Loaded() {

    };
    Loaded.value = new Loaded();
    return Loaded;
})();
var Failed = (function () {
    function Failed() {

    };
    Failed.value = new Failed();
    return Failed;
})();
var initialList = {
    transfers: [  ],
    nextId: 1
};
var initialImage = function (baseURL) {
    return {
        baseURL: baseURL,
        loadTryCount: 100,
        loadStatus: Loading.value
    };
};
module.exports = {
    initialList: initialList,
    Loading: Loading,
    Loaded: Loaded,
    Failed: Failed,
    initialImage: initialImage
};
